import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { typography } from '@landsbankinn/ui';
import flatten from 'lodash.flatten';
import groupBy from 'lodash.groupby';
import React from 'react';
import {
  AtmOpeningHours,
  AtmType,
} from '../../../../__generated__/globalTypes';
import type { FetchServicePoints_servicePoints_nodes } from '../../../graphql/__generated__/FetchServicePoints';
import { CardItem } from '../card/CardItem';
import { OpeningHours } from '../icons/OpeningHours';
import { LocationCard } from '../servicePointCard/servicePointCard';
import res from './servicePointDetailCard.res';

const Container = styled.div<{ spliter?: boolean }>`
  ${(props) =>
    props.spliter
      ? `padding-top: 28px; 
      border-top: 1px solid rgba(30, 61, 90, 0.1);`
      : ''}
`;

const Title = styled.h3`
  ${typography.h5}
  margin-bottom: 8px;
`;

const ServiceTextContainer = styled.div`
  margin-bottom: 28px;
`;

const ServiceText = styled.p`
  ${typography.bodySmall}
  margin-bottom: 4px;
`;

interface IProps {
  showOnMap?: boolean;
  location: FetchServicePoints_servicePoints_nodes;
}
export const ServicePointDetailCard: React.FC<IProps> = ({ location }) => {
  const { r } = useResource();
  const services = React.useMemo(() => {
    return {
      branch:
        location.branches && location.branches?.length !== 0
          ? {
              services: flatten(
                location.branches?.map((i) => i.branchServices),
              ),
              openingHours: location.branches[0].openingHours,
              atms: location.atms?.filter(
                (atm) => atm.openingHours.type === AtmOpeningHours.BranchHours,
              ),
            }
          : undefined,

      atms: groupBy(
        location.branches && location.branches?.length === 1
          ? location.atms?.filter(
              (atm) => atm.openingHours.type !== AtmOpeningHours.BranchHours,
            )
          : location.atms,
        (atm) => atm.openingHours.text,
      ),
    };
  }, [location]);

  return (
    <>
      <LocationCard location={location}>
        {services.branch && (
          <Container>
            <Title>Þjónusta í útibúi</Title>
            <ServiceTextContainer>
              {services.branch?.services.map((i) => (
                <>
                  {i && res[i] && (
                    <ServiceText key={i}>{r(res[i])}</ServiceText>
                  )}
                </>
              ))}
              {services.branch?.atms && services.branch.atms.length > 0 && (
                <>
                  {services.branch?.atms?.map((i) => (
                    <>
                      {i.type && res[i.type] && (
                        <ServiceText key={i.type + i.name}>
                          {r(res[i.type])}
                          {i.type === AtmType.CurrencyAtm &&
                            ` (${i.currencies?.toString()})`}
                        </ServiceText>
                      )}
                    </>
                  ))}
                </>
              )}
            </ServiceTextContainer>

            <CardItem
              svg={<OpeningHours />}
              text={services.branch.openingHours}
            />
          </Container>
        )}

        {location.atms && (
          <>
            {Object.keys(services.atms).map((key) => (
              <>
                <Container key={key} spliter={services.branch !== undefined}>
                  <Title>{r(res.atmsServices)}</Title>
                  <ServiceTextContainer>
                    {services.atms[key].map((a) => (
                      <>
                        {a.type && res[a.type] && (
                          <ServiceText key={a.type + a.name}>
                            {r(res[a.type])}
                            {a.type === AtmType.CurrencyAtm
                              ? ` (${a.currencies?.toString()})`
                              : ''}
                          </ServiceText>
                        )}
                      </>
                    ))}
                  </ServiceTextContainer>
                  <CardItem
                    svg={<OpeningHours />}
                    text={services.atms[key][0].openingHours.text}
                  />
                </Container>
              </>
            ))}
          </>
        )}
      </LocationCard>
    </>
  );
};
